import { createSlice } from "@reduxjs/toolkit";
import React, { useState } from 'react';
import Cv from "../Pages/SideMenu/proposal_prep_CV/Cv"
const initialState = {
  menuItem: [
    {
      access: true,
      active: true,
      icon: "home",
      key: "home",
      path: "dashboard",
      permission: {
        create: true,
        delete: true,
        edit: true,
        view: true,
      },
      subMenu: [

        {
          access: true,
          icon: "dashboard",
          key: "dashboard",
          path: "dashboard",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Dashboard",
        },
        {
          access: true,
          active: false,
          icon: "people",
          key: "Approval",
          path: "Approval",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [
            { name: "Tab 1", content: "Content for Tab 1" },
            { name: "Tab 2", content: "Content for Tab 2" },
          ],
          title: "Approval",
        },
         {
          access: true,
          active: false,
          icon: "myrequest" , 
          key: "My Request",
          path:  "My Request",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [
            { name: "Tab 1", content: "Content for Tab 1" },
            { name: "Tab 2", content: "Content for Tab 2" },
          ],
          title:  "My Request",
        },
      ],
      title: "Home",
    },
    {
      access: true,
      icon: "dashboard", // This icon will be removed from the parent item if you don't want it
      key: "proposalprep",
      path: "proposalprep",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      title: "Proposalprep",
      subMenu: [
        {
          access: true,
          key: "cv",
          path: "Cv",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Cv",
        },
        {
          access: true,
          key: "companyProfile",
          path: "companyProfile",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Company Profile",
        },
        {
          access: true,
          key: "designSoftcopy",
          path: "designSoftcopy",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Design Softcopy",
        },
        {
          access: true,
          key: "credential",
          path: "credential",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Credential",
        },
        {
          access: true,
          key: "templates",
          path: "templates",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Templates",
        },
        {
          access: true,
          key: "referenceLetter",
          path: "referenceLetter",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Reference Letter",
        },
        {
          access: true,
          key: "feesCalculation",
          path: "feesCalculation",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Fees Calculation",
        },
      ],
      title: "Proposal prep",
    },
    {
      access: true,
      active: true,
      icon: "home",
      key: "home",
      path: "dashboard",
      permission: {
        create: true,
        delete: true,
        edit: true,
        view: true,
      },
      subMenu: [
        {
          access: true,
          active: false,
          icon: "people",
          key: "Approval",
          path: "Approval",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [], 
  title: "Proposal",
  path: "Proposal",
        },
      ],
      title: "Proposal",
    },
  ],    

  activeMenuList: [
    {
      access: true,
      icon: "dashboard",
      key: "dashboard",
      path: "dashboard",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      title: "Dashboard",
    },
    {
      access: true,
      active: false,
      icon: "people",
      key: "Approval",
      path: "Approval",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      subMenu: [],
      tabs: [
        { name: "Tab 1", content: "Content for Tab 1" },
        { name: "Tab 2", content: "Content for Tab 2" },
      ],
      title: "Approval",
    }, {
      access: true,
      active: false,
      icon: "myrequest" , 
      key: "My Request",
      path:  "My Request",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      subMenu: [],
      tabs: [
        { name: "Tab 1", content: "Content for Tab 1" },
        { name: "Tab 2", content: "Content for Tab 2" },
      ],
      title:  "My Request",
    },
  ],
  isSideBarCollapsed: false,
  addGroupData: [],
  usersList: [],
  editUserData: {},
  editGroupData: {},
  initialLoader: true,
};

export const systemSlice = createSlice({
  name: "systemSlice",
  initialState,
  reducers: {
    setInitialLoader: (state, action) => {
      return {
        ...state,
        initialLoader: action.payload,
      };
    },
    setUsersList: (state, action) => {
      return {
        ...state,
        usersList: action.payload,
      };
    },
    setMenuItemData: (state, action) => {
      return {
        ...state,
        menuItem: action.payload,
      };
    },

    setActiveMenuList: (state, action) => {
      return {
        ...state,
        activeMenuList: action.payload,
      };
    },

    setIsSideBarCollapsed: (state, action) => {
      return {
        ...state,
        isSideBarCollapsed: action.payload,
      };
    },
    setEditUserData: (state, action) => {
      return {
        ...state,
        editUserData: action.payload,
      };
    },
    setEditGroupData: (state, action) => {
      return {
        ...state,
        editGroupData: action.payload,
      };
    },
    setAddGroupData: (state, action) => {
      return {
        ...state,
        addGroupData: action.payload,
      };
    },
  },
});

export const {
  setInitialLoader,
  setMenuItemData,
  setActiveMenuList,
  setIsSideBarCollapsed,
  setEditUserData,
  setAddGroupData,
  setUsersList,
  setEditGroupData
} = systemSlice.actions;

export const systemReducer = systemSlice.reducer;
